import React from 'react';
import cx from 'clsx';
import PropTypes from 'prop-types';
import { Card, Divider } from '@material-ui/core';
import { Typography } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootPanel: {
    overflow: 'unset',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 9,
  },
  rootHoverBordered: {
    overflow: 'unset',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 9,
    position: 'relative',
  },
  rootScrollHeader: {
    overflow: 'unset',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0px 0px 9px 9px',
  },
  titleContainer: {
    marginTop: 20,
    padding: '5px 12px',
    backgroundColor: '#1ab7a7',
    width: 'fit-content',
    height: 'fit-content',
    borderRadius: '0px 20px 20px 0px',
    minWidth: 70,
  },
  bordered: {
    border: '1px solid #1ab7a7',
  },
}));

const Panel = (props) => {
  const classes = useStyles();
  const {
    height,
    fullHeight = false,
    children,
    withAnimation = true,
    title,
    icon,
    style = {},
    type = 'panel', // panel, hoverBordered, scrollHeader
    padding,
    bordered = false,
    tightToTop = false,
    subHeader,
  } = props;

  const border = type === 'hoverBordered' ? true : bordered;

  return (
    <Card
      className={cx({
        zoomIn: withAnimation,
        [classes.rootPanel]: type === 'panel',
        [classes.rootHoverBordered]: type === 'hoverBordered',
        [classes.rootScrollHeader]: type === 'scrollHeader',
        [classes.bordered]: border === true,
      })}
      style={{
        ...style,
        height: fullHeight ? '100%' : height,
        boxShadow: 'rgba(0, 0, 0, 0.10) 0px 10px 10px, rgba(0, 0, 0, 0.15) 0px 6px 6px',
      }}
    >
      {title && type === 'scrollHeader' && title}
      {title && type === 'hoverBordered' && (
        <div
          className={classes.titleContainer}
          style={{
            position: tightToTop ? 'absolute' : 'unset',
          }}
        >
          <Typography variant="body1" color="#FFFFFF">
            {title}
          </Typography>
        </div>
      )}
      <div style={{ padding: padding || 20, height: '100%' }}>
        {title && type === 'panel' && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {icon && (
                  <FontAwesomeIcon
                    icon={icon}
                    size="lg"
                    color="#1ab7a7"
                    style={{ marginRight: 5 }}
                  />
                )}
                <Typography variant="h6" type="bold">
                  {title}
                </Typography>
              </div>
              {subHeader && subHeader}
            </div>
            <Divider
              width={'100%'}
              style={{
                marginTop: 5,
                marginBottom: 10,
                backgroundColor: '#bfbfbf',
                height: '1.5px',
              }}
            />
          </>
        )}
        {children}
      </div>
    </Card>
  );
};

Panel.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Panel;
